(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const header = document.querySelector('[data-norgira-header]');
    if (!header || header.dataset.ready) return;
    header.dataset.ready = 'true';
    const shell = header.closest('[data-norgira-header-shell]');
    const menu = header.querySelector('#NorgiraMobileMenu');
    const toggle = header.querySelector('[data-norgira-menu-toggle]');
    const searchPanel = header.querySelector('[data-norgira-search-panel]');
    const searchInput = header.querySelector('[data-norgira-search-input]');
    const searchForm = header.querySelector('[data-norgira-search-form]');
    const searchResults = header.querySelector('[data-norgira-search-results]');
    const searchTriggers = [...header.querySelectorAll('[data-norgira-search-open]')];
    let searchTimer;
    let predictiveTimer;
    let predictiveController;

    let menuTimer;
    const desktopNavigation = matchMedia('(min-width: 1200px)');
    const closeMenu = () => {
      if (!menu || !toggle) return;
      clearTimeout(menuTimer);
      menu.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('norgira-menu-open');
      menuTimer = setTimeout(() => { menu.hidden = true; }, 300);
    };

    const openMenu = () => {
      if (!menu || !toggle || desktopNavigation.matches) return;
      clearTimeout(menuTimer);
      // norgira-mobile-drawer-body-portal-2026-10-15: keep the fixed drawer viewport-sized even when the sticky header has a transform.
      if (menu.parentElement !== document.body) document.body.appendChild(menu);
      menu.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
      document.body.classList.add('norgira-menu-open');
      requestAnimationFrame(() => requestAnimationFrame(() => menu.classList.add('is-open')));
    };

    const openSearch = (event) => {
      event?.preventDefault();
      clearTimeout(searchTimer);
      if (searchPanel.parentElement !== document.body) document.body.appendChild(searchPanel);
      searchPanel.hidden = false;
      searchPanel.setAttribute('aria-hidden', 'false');
      searchTriggers.forEach((trigger) => trigger.setAttribute('aria-expanded', 'true'));
      document.body.classList.add('norgira-search-open');
      requestAnimationFrame(() => requestAnimationFrame(() => {
        searchPanel.classList.add('is-open');
        searchInput?.focus({ preventScroll: true });
        const end = searchInput?.value.length || 0;
        searchInput?.setSelectionRange?.(end, end);
      }));
    };

    const closeSearch = () => {
      searchPanel.classList.remove('is-open');
      searchPanel.setAttribute('aria-hidden', 'true');
      searchTriggers.forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'));
      document.body.classList.remove('norgira-search-open');
      predictiveController?.abort();
      searchTimer = setTimeout(() => { searchPanel.hidden = true; }, 300);
    };

    const createSearchLink = (className, href, text) => {
      const link = document.createElement('a');
      link.className = className;
      link.href = href;
      link.textContent = text;
      return link;
    };

    const renderPredictive = (term, payload) => {
      if (!searchResults) return;
      const resources = payload?.resources?.results || {};
      const queries = (resources.queries || []).slice(0, 3);
      const suggestions = queries.length ? queries : [{ text: term, url: '/search?q=' + encodeURIComponent(term) + '&type=product' }];
      const products = (resources.products || []).slice(0, 4);
      searchResults.replaceChildren();
      if (!suggestions.length && !products.length) {
        searchResults.hidden = true;
        return;
      }
      if (suggestions.length) {
        const section = document.createElement('section');
        section.className = 'norgira-header-search__result-section';
        const title = document.createElement('h2');
        title.textContent = 'SUGGESTIONS';
        section.append(title);
        suggestions.forEach((query) => section.append(createSearchLink('norgira-header-search__suggestion', query.url || ('/search?q=' + encodeURIComponent(query.text || term)), query.text || term)));
        searchResults.append(section);
      }
      if (products.length) {
        const section = document.createElement('section');
        section.className = 'norgira-header-search__result-section';
        const title = document.createElement('h2');
        title.textContent = 'PRODUCTS';
        section.append(title);
        products.forEach((product) => {
          const link = createSearchLink('norgira-header-search__product', product.url, '');
          const image = document.createElement('img');
          image.src = product.featured_image?.url || product.image || '';
          image.alt = product.featured_image?.alt || product.title || '';
          image.loading = 'lazy';
          const copy = document.createElement('span');
          copy.className = 'norgira-header-search__product-copy';
          [product.vendor, product.title, product.price].filter(Boolean).forEach((value) => {
            const line = document.createElement('span');
            line.textContent = value;
            copy.append(line);
          });
          link.append(image, copy);
          section.append(link);
        });
        searchResults.append(section);
      }
      const viewAll = createSearchLink('norgira-header-search__view-all', '/search?q=' + encodeURIComponent(term) + '&type=product', 'View all');
      searchResults.append(viewAll);
      searchResults.hidden = false;
    };

    const loadPredictive = () => {
      const term = searchInput?.value.trim() || '';
      clearTimeout(predictiveTimer);
      predictiveController?.abort();
      if (!term) {
        if (searchResults) { searchResults.hidden = true; searchResults.replaceChildren(); }
        return;
      }
      predictiveTimer = setTimeout(async () => {
        predictiveController = new AbortController();
        try {
          const params = new URLSearchParams({ q: term, 'resources[type]': 'query,product', 'resources[limit]': '4', 'resources[options][unavailable_products]': 'show' });
          const response = await fetch('/search/suggest.json?' + params.toString(), { signal: predictiveController.signal, headers: { Accept: 'application/json' } });
          if (!response.ok) throw new Error('Predictive search failed');
          renderPredictive(term, await response.json());
        } catch (error) {
          if (error.name !== 'AbortError' && searchResults) searchResults.hidden = true;
        }
      }, 120);
    };
    searchInput?.addEventListener('input', loadPredictive);
    searchInput?.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' && searchInput.value.trim()) searchForm?.requestSubmit();
    });

    const syncSticky = () => {
      if (!shell) return;
      const height = header.getBoundingClientRect().height || (desktopNavigation.matches ? 115.5 : 79.4);
      const threshold = shell.dataset.norgiraHeaderMode === 'overlay' ? 1 : height;
      shell.classList.toggle('norgira-header-section--fixed', window.scrollY > threshold);
    };

    toggle?.addEventListener('click', () => {
      if (menu.hidden) openMenu();
      else closeMenu();
    });
    header.querySelectorAll('[data-norgira-menu-close]').forEach((el) => el.addEventListener('click', closeMenu));
    searchTriggers.forEach((trigger) => trigger.addEventListener('click', openSearch));
    header.querySelector('[data-norgira-search-close]')?.addEventListener('click', closeSearch);
    header.querySelector('.norgira-header__mobile-cart')?.addEventListener('click', (event) => {
      const drawer = document.querySelector('cart-drawer');
      if (!drawer || typeof drawer.open !== 'function') return;
      event.preventDefault();
      drawer.open(event.currentTarget);
    });
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      if (menu && !menu.hidden) closeMenu();
      if (searchPanel && !searchPanel.hidden) closeSearch();
    });
    window.addEventListener('scroll', syncSticky, { passive: true });
    window.addEventListener('resize', syncSticky, { passive: true });
    desktopNavigation.addEventListener('change', () => {
      if (desktopNavigation.matches) closeMenu();
    });
    syncSticky();
  })();

  } catch(e) { console.error(e); }
})();
})();
